// extracted by mini-css-extract-plugin
module.exports = {"main":"Slider_main__QpsVp","label":"Slider_label__33xyu","container":"Slider_container__u1Sbq","slider":"Slider_slider__3xOpH","rangeValue":"Slider_rangeValue__6k90F"};